import React, { useEffect, useState } from "react";
import styles from "./PreviewDocument.module.scss";
import { ReactComponent as MoreInfoIcon } from "assets/svg/InformationIcon.svg";
import { ReactComponent as CrossIcon } from "assets/svg/x.svg";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import Modal from "components/shared/modal/Modal";
import Button from "components/shared/button/Button";
import { fetchImage } from "utils/utils";
const PreviewDocument = (props) => {
  const [showIcon, setShowIcon] = useState(
    props?.data?.showInstructions || false
  );
  const [fileData, setFileData] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      setFileData({
        name: file.name,
        size: (file.size / 1024).toFixed(2) + " KB",
      });
    }
  };

  const handleRemoveFile = () => {
    setFileData(null);
    setModalOpen(false);
  };

  return (
    <div className={styles.mainContainer}>
      <div className={styles.mainContent}>
        <div className={styles.heading}>
          <span>
            {" "}
            {props?.data?.required && <span style={{ color: "red" }}>*</span>}
            {props?.data?.value || props?.name || props?.label}
          </span>
          {props?.instructions || props?.data?.media?.length ? (
            <div className={styles?.icon}>
              {showIcon ? (
                <CrossIcon onClick={() => setShowIcon((prev) => !prev)} />
              ) : (
                <MoreInfoIcon onClick={() => setShowIcon((prev) => !prev)} />
              )}
            </div>
          ) : null}
        </div>

        {!fileData ? (
          <div className={styles.inputText}>
            <label htmlFor="file-upload" className={styles.uploadLabel}>
              <span>
                <AttachFileIcon />
              </span>
              <span>Add Document</span>
            </label>
            <input
              id="file-upload"
              type="file"
              className={styles.textField}
              onChange={handleFileUpload}
              placeholder="text"
            />
          </div>
        ) : (
          <div
            className={styles.filePreview}
            onClick={() => setModalOpen(true)}
          >
            <div>
              <span className={styles.fileName}>{fileData.name}</span>
              <span className={styles.fileSize}>({fileData.size})</span>
            </div>
          </div>
        )}
      </div>
      {modalOpen && (
        <Modal
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          isCancel={false}
          bottom={false}
          blur={false}
        >
          <>
            <div>
              <p className={styles?.doc_delete_heading}>
                Are you sure you want to delete this document?
              </p>
              <div className={styles?.btn_container}>
                <Button className={styles?.danger} onClick={handleRemoveFile}>
                  Delete
                </Button>
                <Button
                  className={styles?.primary}
                  onClick={() => setModalOpen(false)}
                >
                  Cancel
                </Button>
              </div>
            </div>
          </>
          {/* <CrossIcon className={styles.removeIcon} onClick={handleRemoveFile} /></> */}
        </Modal>
      )}
      {showIcon && (
        <div className={styles.subContent}>
          {props?.instructions && (
            <div className={styles.instructionText}>
              {props?.instructions}
            </div>
          )}
          {props?.data?.media?.length ? (
            <>
              {props?.data?.media.map((image) => (
                <img
                  className={styles.imageStyle}
                  src={image.path}
                  alt="Preview"
                />
              ))}
            </>
          ) : null}
        </div>
      )}
    </div>
  );
};

export default PreviewDocument;
